export default __webpack_public_path__ + "static/media/step_change.0e5ef5a9.png";